module.exports = __webpack_public_path__ + "static/media/online_courses_Chao_Yuen-Ren.b68c878c.jpg";